import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { HomeApi, HomeApiImpl } from './apis/home-api';
import { HomeRdApi, HomeRdApiImpl } from './apis/home-rd-api';

export const homeContainer = new ContainerModule((bind) => {
    bind(HomeRdApi).to(HomeRdApiImpl);
    bind(HomeApi).to(HomeApiImpl);
});
